import { useCallback, useContext, useEffect, useRef } from "react";
import { CategoryRelevancyContext } from "../contexts/CategoryRelevancyContext";

export const useMenuControl = () => {
  const filterRef = useRef<HTMLDivElement | null>(null);
  const topItemsRef = useRef<HTMLDivElement | null>(null);
  const settingsRef = useRef<HTMLDivElement | null>(null);

  const { openMenu, setOpenMenu } = useContext(CategoryRelevancyContext);

  const toggleMenu = useCallback((menuName: "filter" | "topItems" | "settings" | undefined) => {
    setOpenMenu(prev => prev === menuName ? undefined : menuName);
  }, [setOpenMenu]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (!openMenu) return;

      if (openMenu === 'filter' && filterRef.current) {
        const isOutsideFilter = !filterRef.current.contains(e.target as Node);
        if (isOutsideFilter) setOpenMenu(undefined);
      }
      else if (openMenu === 'topItems' && topItemsRef.current) {
        const isOutsideTopItems = !topItemsRef.current.contains(e.target as Node);
        if (isOutsideTopItems) setOpenMenu(undefined);
      }
      else if (openMenu === 'settings' && settingsRef.current) {
        const isOutsideSettings = !settingsRef.current.contains(e.target as Node);
        if (isOutsideSettings) setOpenMenu(undefined);
      }
    };

    if (openMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openMenu, setOpenMenu]);

  return { toggleMenu, filterRef, topItemsRef, settingsRef };
};